const dotenv = require('dotenv');

dotenv.config();
module.exports = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  ENABLE_REDUX_LOGGER: process.env.ENABLE_REDUX_LOGGER || false,
  FILE_SIZE_LIMIT_PDF: process.env.FILE_SIZE_LIMIT_PDF || 100,
  FILE_SIZE_LIMIT_PIC: process.env.FILE_SIZE_LIMIT_PIC || 1,
};
